import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles((theme: Theme) => ({
    maderaLoaderWrapper: {
        width: theme.spacing(20),
        height: theme.spacing(20),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    // Real Madera mark, gently pulsing (scale + fade) as a branded spinner. Sized
    // near the 64px source so it stays crisp rather than being upscaled.
    loaderMark: {
        width: "80px",
        height: "80px",
        objectFit: "contain",
        animationDuration: "1.1s",
        animationIterationCount: "infinite",
        animationTimingFunction: "ease-in-out",
        animationName: "$maderaPulse",
        transformOrigin: "center center",
    },
    "@keyframes maderaPulse": {
        "0%": {
            transform: "scale(0.82)",
            opacity: 0.45,
        },
        "50%": {
            transform: "scale(1)",
            opacity: 1,
        },
        "100%": {
            transform: "scale(0.82)",
            opacity: 0.45,
        },
    },
}));
